"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.noticeDetailsLiteUIExport = void 0;
exports.noticeDetailsLiteUIExport = [
    {
        headerName: 'Notice ID',
        field: 'noticeId',
    },
    {
        headerName: 'External Id',
        field: 'externalId',
    },
    {
        headerName: 'Notice Url',
        field: 'noticeUrl',
    },
    {
        headerName: 'Tender Name',
        field: 'contractTitle',
    },
    {
        headerName: 'Country',
        field: 'entityIsoCountry',
    },
    {
        headerName: 'Buyer Name Derived',
        field: 'buyerNameDerived',
    },
    {
        headerName: 'Contract CPV Code',
        field: 'contractCpvCode',
    },
    {
        headerName: 'Published Date',
        field: 'publishedDate',
    },
    {
        headerName: 'Expiry Date',
        field: 'closeSubmissionDate',
    },
    {
        headerName: 'Contract Duration Days',
        field: 'contractDurationDays',
    },
    {
        headerName: 'Contract Start Date',
        field: 'contractStartDate',
    },
    {
        headerName: 'Estimated Close Submission Date',
        field: 'estimatedCloseSubmissionDate',
    },
    {
        headerName: 'Estimated Open Submission Date',
        field: 'estimatedOpenSubmissionDate',
    },
    {
        headerName: 'Contract Renewal Date',
        field: 'contractRenewalDate',
    },
    {
        headerName: 'Contract value',
        field: 'contractValue',
    },
    {
        headerName: 'Contract Value Currency',
        field: 'contractValueCurrency',
    },
    {
        headerName: 'Notice Document Url',
        field: 'noticeDocumentUrl',
    },
    {
        headerName: 'Non Price Criteria Name (pipe separated)',
        field: 'lotCriteriaQuality',
    },
    {
        headerName: 'Non Price Criteria Weight (pipe separated)',
        field: 'lotCriteriaQualityWeight',
    },
    {
        headerName: 'Price Criteria Name',
        field: 'lotCriteriaPrice',
    },
    {
        headerName: 'Price Criteria Weight',
        field: 'lotCriteriaPriceWeight',
    },
    {
        headerName: 'Lot Number',
        field: 'lotNumber',
    },
    {
        headerName: 'Lot Title',
        field: 'lotTitle',
    },
    {
        headerName: 'Lot Procurement Description',
        field: 'lotProcurementDescription',
    },
    {
        headerName: 'Lot Volume',
        field: 'lotVolume',
    },
    {
        headerName: 'Lot Value',
        field: 'lotValue',
    },
    {
        headerName: 'Lot Value Currency',
        field: 'lotValueCurrency',
    },
    {
        headerName: 'Lot Cpv',
        field: 'lotCpv',
    },
    {
        headerName: 'Lot CPV Code',
        field: 'lotCpvCode',
    },
    {
        headerName: 'Vam Id',
        field: 'vamId',
    },
    {
        headerName: 'Notice Vam Id',
        field: 'noticeVamId',
    },
    {
        headerName: 'Sub Lot Number',
        field: 'subLotNumber',
    },
    {
        headerName: 'Sub Lot Title',
        field: 'subLotTitle',
    },
    {
        headerName: 'Sub Lot Quantity',
        field: 'subLotQuantity',
    },
    {
        headerName: 'Sub Lot Form',
        field: 'subLotForm',
    },
];
//# sourceMappingURL=data:application/json;base64,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